export class AnalyticsDisabledError extends Error {
  public constructor() {
    super('Analytics Disabled')

    Object.setPrototypeOf(this, AnalyticsDisabledError.prototype)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    /* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AnalyticsDisabledError)
    }
    this.name = this.constructor.name
  }
}
